import { render, staticRenderFns } from "./FamilyActivityPendingTexts.vue?vue&type=template&id=e9e82b38&scoped=true&"
import script from "./FamilyActivityPendingTexts.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityPendingTexts.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActivityPendingTexts.vue?vue&type=style&index=0&id=e9e82b38&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e82b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
